/**
 * Identifies which version of first run content the user is seeing.
 * Incrementing should reset a user's FirstRunCompletion status.
 */
export var firstRunVersion = 1;
export var secondRunVersion = 1;
//# sourceMappingURL=constants.js.map